import {
  Component,
  input,
  output,
  computed,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { lucideChevronDown } from '@ng-icons/lucide';
import { HlmBadgeDirective } from '@spartan-ng/helm/badge';
import { HlmMenuImports } from '@spartan-ng/helm/menu';
import { BrnMenuTriggerDirective } from '@spartan-ng/brain/menu';
import {
  Analysis,
  BusinessStatus,
  BUSINESS_STATUS_METADATA,
  BUSINESS_STATUS_OPTIONS,
} from '@shared/models/analysis.model';

@Component({
  selector: 'app-analysis-status-selector',
  standalone: true,
  imports: [
    CommonModule,
    NgIconComponent,
    HlmBadgeDirective,
    BrnMenuTriggerDirective,
    ...HlmMenuImports,
  ],
  providers: [
    provideIcons({
      lucideChevronDown,
    }),
  ],
  templateUrl: './analysis-status-selector.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisStatusSelector {
  analysis = input.required<Analysis>();
  disabled = input<boolean>(false);

  statusChanged = output<BusinessStatus>();

  currentStatus = computed(() => this.analysis().businessStatus);

  currentStatusMetadata = computed(() => {
    const status = this.currentStatus();
    return status ? BUSINESS_STATUS_METADATA[status] : undefined;
  });

  availableStatusOptions = computed(() => BUSINESS_STATUS_OPTIONS);

  getStatusColor(status: BusinessStatus | null | undefined): string {
    if (!status || !BUSINESS_STATUS_METADATA[status]) {
      return 'bg-muted text-foreground border-border';
    }
    return BUSINESS_STATUS_METADATA[status].badgeClass;
  }

  getStatusLabel(status: BusinessStatus | null | undefined): string {
    if (!status || !BUSINESS_STATUS_METADATA[status]) {
      return 'Ausstehend';
    }
    return BUSINESS_STATUS_METADATA[status].label;
  }

  onStatusSelect(newStatus: BusinessStatus): void {
    if (this.currentStatus() !== newStatus && !this.disabled()) {
      this.statusChanged.emit(newStatus);
    }
  }
}
